// src/services/projects.js

const API_BASE = 'https://new.sbdemolition.online/api/projects';

async function apiRequest(endpoint, options = {}) {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
      ...options.headers
    }
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    window.location.href = '/login';
    return;
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Network error' }));
    throw new Error(error.error || error.message || `API Error ${response.status}`);
  }

  return response.json();
}

// ✅ دالة خاصة لرفع الملفات (FormData)
async function uploadWithFiles(endpoint, formData) {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_BASE}${endpoint}`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      ...(token && { 'Authorization': `Bearer ${token}` })
    },
    body: formData
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    window.location.href = '/login';
    return;
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Network error' }));
    throw new Error(error.error || error.message || `API Error ${response.status}`);
  }

  return response.json();
}

// ✅ Helper function to format bytes
function formatBytes(bytes) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
}

export const projectsAPI = {
  list: (params = {}) => {
    const query = new URLSearchParams();
    if (params.archived !== undefined) query.append('archived', params.archived);
    if (params.status) query.append('status', params.status);
    if (params.search) query.append('search', params.search);
    return apiRequest(`/list.php?${query.toString()}`);
  },

  details: (id) => apiRequest(`/details.php?id=${id}`),

  // ✅ Create مع دعم رفع الملفات
  create: (data, files = []) => {
    if (files.length > 0) {
      const formData = new FormData();

      Object.keys(data).forEach(key => {
        if (key !== 'attachments' && key !== 'email_attachments' && data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key]);
        }
      });

      files.forEach((file, index) => {
        const category = file.category || 'general';
        const fileBlob = file.fileObject || file;
        const fileName = file.name || `file_${index}`;

        if (category === 'emails') {
          formData.append('email_attachments[]', fileBlob, fileName);
        } else {
          formData.append('attachments[]', fileBlob, fileName);
        }
      });

      return uploadWithFiles('/create.php', formData);
    } else {
      return apiRequest('/create.php', {
        method: 'POST',
        body: JSON.stringify(data)
      });
    }
  },

  // ✅ Update مع دعم رفع الملفات
  update: (id, data, files = []) => {
    if (files.length > 0) {
      const formData = new FormData();

      Object.keys(data).forEach(key => {
        if (key !== 'attachments' && key !== 'email_attachments' && data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key]);
        }
      });

      files.forEach((file, index) => {
        const category = file.category || 'general';
        const fileBlob = file.fileObject || file;
        const fileName = file.name || `file_${index}`;

        if (category === 'emails') {
          formData.append('email_attachments[]', fileBlob, fileName);
        } else {
          formData.append('attachments[]', fileBlob, fileName);
        }
      });

      return uploadWithFiles(`/update.php?id=${id}`, formData);
    } else {
      return apiRequest(`/update.php?id=${id}`, {
        method: 'PUT',
        body: JSON.stringify(data)
      });
    }
  },

  updateStatus: (id, status) => apiRequest(`/update-status.php?id=${id}`, {
    method: 'PUT',
    body: JSON.stringify({ status })
  }),

  updateProjectStatus: (id, projectStatus) => apiRequest(`/update-project-status.php?id=${id}`, {
    method: 'PUT',
    body: JSON.stringify({ project_status: projectStatus })
  }),

  // ✅ Follow Up Counter
  updateFollowup: (id, action) => apiRequest(`/followup.php?id=${id}`, {
    method: 'PUT',
    body: JSON.stringify({ action }) // 'increment' | 'decrement'
  }),

  archive: (id) => apiRequest(`/archive.php?id=${id}`, {
    method: 'PUT'
  }),

  restore: (id) => apiRequest(`/restore.php?id=${id}`, {
    method: 'PUT'
  }),

  delete: (id) => apiRequest(`/delete.php?id=${id}`, {
    method: 'DELETE'
  }),

  archived: () => apiRequest('/archived.php'),

  // ✅ Financial Summary
  financialSummary: () => apiRequest('/financial-summary.php')
};
